// extracted by mini-css-extract-plugin
module.exports = {"container":"Success_container_3Cykz","headline":"Success_headline_2OkNV","title":"Success_title_MSriP"};